<ig-button class="ig-alt-btn" (trigger)="btnClick()">search</ig-button>
<span class="ig-alt-cover" (click)="btnCancel($event)"></span>





// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/alt.button/alt.button.component.html